import React from 'react';

const FrequencyTip = () => {
    return (
        <div>
            <div><b>Continuously</b> is defined as 6-8 hours in an 8-hour day or greater than 60 times per hour.</div>
            <br/>
            <div><b>Frequently</b> is defined as 3-6 hours in an 8-hour day or up to 12-60 times per hour.</div>
            <br/>
            <div><b>Occasionally</b> is defined as up to 3 hours in an 8-hour day or 1-12 times per hour.</div>
        </div>
    )
};
export default FrequencyTip;